<template>
    <div>
        <div class="userInfo-wrapper">
            <div class="userInfo-border">
                <h5>
                    备注信息
                    <el-button size="mini" type="primary" v-if="order.finance"  @click="showMemoDialog">编辑备注</el-button>
                </h5>
                <div class="" v-if="!order.finance.memo" style="text-align:center; font-size:14px; color:#909399;">暂无数据</div>
                <div v-else style="padding: 4px 24px">{{order.finance.memo}}</div>
            </div>
        </div>
        <div class="userInfo-wrapper">
            <div class="userInfo-border">
                <h5>开设学段</h5>
                <div class="" v-if="!order.finance"
                     style="text-align:center; font-size:14px; color:#909399;">暂无数据
                </div>
                <div v-else style="padding: 4px 24px">{{order.finance.open_xd_memo}}</div>
            </div>
        </div>
        <!-- 添加表单 -->
        <MemoForm :params='params' v-if="dialogMemoVisible" @submit='changeMemo'></MemoForm>
    </div>
</template>

<script>
    import MemoForm from "~/views/order/dialog/memoForm.vue";
    export default {
        name: "order_finance_other",
        props: {
            order: {
                required: true
            },
        },
        components:{
            MemoForm
        },

        data() {
            return {
                params: {
                    order_id: '',
                    memo: '',
                },
                dialogMemoVisible: false,
                loading: false
            };
        },

        methods:{
            showMemoDialog(){
                this.params = {
                    order_id: this.order.id,
                    memo: this.order.finance ? this.order.finance.memo : '',
                }
                this.dialogMemoVisible = true;
            },

            changeMemo(data){
                this.order.finance.memo = data.memo;
                this.params = {
                    order_id: '',
                    memo: '',
                };
                this.dialogMemoVisible = false;
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/partial/order_finance_other.vue